const state = () => ({
    liberal: false,
    locative: false,
})

const getters = {
    getLiberal: (state) => {
        return state.liberal
    },
    getLocative: (state) => {
        return state.locative
    },
}

const actions = {
    setLiberal({ commit }, value) {
        commit("SET_LIBERAL", value)
    },

    setLocative({ commit }, value) {
        commit("SET_LOCATIVE", value)
    },
}

const mutations = {
    SET_LIBERAL(state, value) {
        state.liberal = value
    },
    SET_LOCATIVE(state, value) {
        state.locative = value
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
